<template>
  <BranchList :config="config" />
</template>

<script>
import BranchList from "../../components/BranchList/BranchList.vue";

export default {
  name: "app",
  components: {
    BranchList
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
